import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-horizontal-card-section',
  templateUrl: './home-horizontal-card-section.component.html',
  styleUrls: ['./home-horizontal-card-section.component.css']
})
export class HomeHorizontalCardSectionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
